import React from "react";
import { Modal } from "react-bootstrap";
import { Users, UserCheck, Film } from "lucide-react";

const FollowersModal = ({
  showFollowersModal,
  setShowFollowersModal,
  dashboardData,
  handleRemoveFollower,
  navigate
}) => {
  return (
    <Modal show={showFollowersModal} onHide={() => setShowFollowersModal(false)} centered dialogClassName="cd-following-modal-dialog" contentClassName="cdd-modal-content">
      <Modal.Header closeButton closeVariant="white" className="cdd-modal-header">
        <Modal.Title className="cdd-modal-title">
          <Users size={18} className="text-primary" /> Followers (Talents Following You)
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="cd-modal-body cdd-modal-body">
        {dashboardData?.followers?.length > 0 ? (
          <div className="cdd-modal-list">
            {dashboardData.followers.map((talent) => (
              <div key={talent.id} className="cdd-modal-card">
                
                <div className="cdd-modal-card-top">
                  <div className="cdd-modal-card-user">
                    <div 
                      className="cdd-modal-avatar"
                      onClick={() => {
                        setShowFollowersModal(false);
                        navigate(`/dashboard/talent-profile/${talent.id}`);
                      }}
                    >
                      {talent.img ? <img src={talent.img} alt={talent.name} className="w-100 h-100" style={{ objectFit: 'cover' }} /> : talent.name.charAt(0)}
                    </div>
                    
                    <div className="cdd-modal-user-meta">
                      <div className="cdd-modal-name-row">
                        <h6 
                          className="cdd-modal-name"
                          onClick={() => {
                            setShowFollowersModal(false);
                            navigate(`/dashboard/talent-profile/${talent.id}`);
                          }}
                        >
                          {talent.name}
                        </h6>
                        <span className="cdd-modal-badge">
                          <UserCheck size={10} className="me-1" color="#ffffff" /> Candidate
                        </span>
                      </div>
                      <small className="cdd-modal-subtext">
                        Candidate
                      </small>
                    </div>
                  </div>

                  <button 
                    className="cdd-modal-remove-btn"
                    onClick={() => handleRemoveFollower(talent.id, talent.name)}
                  >
                    Remove Follower
                  </button>
                </div>

                <div className="cdd-modal-stat-row">
                  <div className="cdd-stat-box">
                    <div className="cdd-stat-icon-circle-blue">
                      <Film size={14} color="#38bdf8" />
                    </div>
                    <div>
                      <div className="cdd-stat-num text-info">{talent.appliedCount || 0}</div>
                      <div className="cdd-stat-lbl text-secondary">Applications</div>
                    </div>
                  </div>
                </div>

              </div>
            ))}
          </div>
        ) : (
          <div className="cdd-modal-empty">
            <Users size={28} className="mb-2 opacity-50" />
            <p className="mb-0 small">No talents are following your profile yet.</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FollowersModal;
